var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-items-center justify-content-between gap-3" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-column justify-content-center flex-grow-1"
        },
        [
          _c("div", [
            _c(
              "label",
              {
                staticClass: "btn btn-sm btn-outline-primary mb-0 shadow-sm",
                class: { disabled: _vm.isUploading }
              },
              [
                _c("i", { staticClass: "fa fa-upload me-1" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.isUploading ? "Uploading..." : "Choose File") +
                    "\n        "
                ),
                _c("input", {
                  staticClass: "d-none",
                  attrs: {
                    type: "file",
                    accept: "image/*",
                    disabled: _vm.isUploading
                  },
                  on: { change: _vm.handleFileSelect }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _vm.filename
            ? _c(
                "small",
                {
                  staticClass:
                    "text-muted d-block text-truncate mt-1 style-filename"
                },
                [
                  _c("i", { staticClass: "fa fa-file-image me-1" }),
                  _vm._v("\n      " + _vm._s(_vm.filename) + "\n    ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c("small", { staticClass: "text-danger d-block mt-1" }, [
                _c("i", { staticClass: "fa fa-exclamation-triangle me-1" }),
                _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-shrink-0 ms-auto" }, [
        _vm.previewUrl
          ? _c(
              "div",
              {
                staticClass:
                  "position-relative overflow-hidden rounded border shadow-sm style-preview-wrapper"
              },
              [
                _c("img", {
                  staticClass: "img-fluid object-fit-cover d-block w-100 h-100",
                  attrs: { src: _vm.previewUrl, alt: _vm.item.name },
                  on: { error: _vm.handleImageError }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-danger btn-sm position-absolute rounded-circle p-0 d-flex align-items-center justify-content-center shadow-sm remove-btn-overlay",
                    attrs: { type: "button", title: _vm.$t("btnDelete") },
                    on: { click: _vm.removeImage }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ]
            )
          : _c(
              "div",
              {
                staticClass:
                  "border rounded bg-light d-flex flex-column align-items-center justify-content-center text-muted style-preview-wrapper"
              },
              [
                _c("i", { staticClass: "fa fa-image fa-lg opacity-50 mb-1" }),
                _vm._v(" "),
                _c("span", { staticClass: "extra-small text-secondary" }, [
                  _vm._v("No image")
                ])
              ]
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }